import { render, staticRenderFns } from "./PreparationAnalysisTableBody.vue?vue&type=template&id=18ab35e2&scoped=true&"
import script from "./PreparationAnalysisTableBody.vue?vue&type=script&lang=ts&"
export * from "./PreparationAnalysisTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./PreparationAnalysisTableBody.vue?vue&type=style&index=0&id=18ab35e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab35e2",
  null
  
)

export default component.exports